import { Fragment, useRef, useState } from 'react';
import { FormikErrors, useField, useFormikContext } from 'formik';

const getFieldCSSClasses = (
  touched: boolean,
  errors:
    | string
    | FormikErrors<any>
    | string[]
    | FormikErrors<any>[]
    | undefined,
  showFeedback: boolean
) => {
  const classes = ['form-control'];
  if (errors && !showFeedback && touched) {
    classes.push('is-invalid');
  }
  if (errors && showFeedback && touched) {
    classes.push('is-invalid');
  }
  if (!errors && showFeedback && touched) {
    classes.push('is-valid');
  }
  return classes.join(' ');
};
const getFieldCSSClassesErrors = (
  errors:
    | string
    | FormikErrors<any>
    | string[]
    | FormikErrors<any>[]
    | undefined
) => {
  const classes = ['form-control'];

  if (errors) {
    classes.push('is-invalid');
  }
  if (!errors) {
    classes.push('is-valid');
  }
  return classes.join(' ');
};
type Props = JSX.IntrinsicElements['input'] & {
  label?: string;
  name: string;
  isRequired?: boolean;
  showError?: boolean;
  autoFocus?: boolean;
  isDisabled?: boolean;
  focus?: boolean;
};

export const CustomInput = ({
  label,
  name,
  isRequired,
  showError = true,
  autoFocus,
  focus = false,
  isDisabled,
  ...props
}: Props): JSX.Element => {
  const [field, meta] = useField(name);
  const inputRef = useRef<HTMLInputElement | null>(null);
  if (field.value === null) field.value = '';
  const { errors } = useFormikContext<any>();
  const [didFocus, setDidFocus] = useState(false);
  const handleFocus = () => setDidFocus(true);
  const required = isRequired ? 'required' : '';
  const errorValue = errors[field.name] ? errors[field.name] : meta.error;

  setTimeout(() => {
    if (!!autoFocus && inputRef !== null && inputRef.current) {
      inputRef.current.focus();
    }
  }, 200);
  return (
    <Fragment>
      {label && <label className={`${required} form-label`}>{label}</label>}
      <input
        ref={inputRef}
        type={props.type}
        className={
          !focus
            ? getFieldCSSClasses(meta.touched, errorValue, didFocus)
            : getFieldCSSClassesErrors(errorValue)
        }
        {...field}
        {...props}
        onFocus={handleFocus}
        autoComplete='none'
        disabled={isDisabled}
      />
      {showError && meta.touched && (meta.error || errors[field.name]) && (
        <div className='invalid-feedback'>{errorValue}</div>
      )}
    </Fragment>
  );
};
